export class Mutex {
  current: Promise<unknown> = Promise.resolve();
  lock() {
    let newResolve: () => void;
    const promise = new Promise<void>((resolve) => {
      newResolve = resolve;
    });
    const unlock$ = this.current.then(() => newResolve);
    this.current = promise;
    return unlock$;
  }
}

export function queue() {
  const mutex = new Mutex();
  return async <T>(fn: () => T): Promise<T> => {
    const unlock = await mutex.lock();
    try {
      const value = await fn();
      unlock();
      return value;
    } catch (ex) {
      console.error(ex);
      unlock();
      return undefined as T;
    }
  };
}
